//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AngularThreshold",0,"Expression",0],[0,"ContinuityType",1,0],[1,"DistanceThreshold",0,"Expression",0],[1,"DynamicLabel",0,"SelectNXObject",0],[0,"EndPointX",1,0],[0,"EndPointY",1,0],[0,"EndPointZ",1,0],[0,"G0Check",1,0],[0,"G0Check2",1,0],[0,"G0Tolerance",1,0],[0,"G1Check",1,0],[0,"G1Check2",1,0],[0,"G1Tolerance",1,0],[0,"G2Check",1,0],[0,"G2Check2",1,0],[0,"G2Tolerance",1,0],[0,"G3Check",1,0],[0,"G3Check2",1,0],[0,"G3Tolerance",1,0],[1,"MultiCurve",0,"SelectDisplayableObjectList",0],[1,"SelectCurve",0,"SelectNXObject",0],[1,"SelectObject",0,"SelectNXObject",0],[0,"ShowDeviation",1,0],[0,"ShowMarkup",1,0],[0,"ShowMaximum",1,0],[0,"ShowMinimum",1,0],[0,"ShowNeedle",1,0],[0,"ShowOutOfTolerance",1,0]],[[[],"ResetShowDeviation",{},0,0]],[]];
SPLM.GeometricAnalysis.CurveContinuityBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.CurveContinuityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.CurveContinuityBuilder.Type = Object.freeze({
    "CurvetoObject" : "CurvetoObject", "Multicurve" : "Multicurve"});

export default SPLM;